export default __webpack_public_path__ + "static/media/info.4eb10646.svg";